import React from "react";
import {Document, Font, Image, Page, StyleSheet, Text, View} from "@react-pdf/renderer";
import {DataTableCell, Table, TableBody, TableCell, TableHeader} from "@david.kucsai/react-pdf-table";
import {DrawingFileInfo} from "./util";
import Roboto from '../../../../../../assets/fonts/Roboto-Regular.ttf';
import RobotoBold from '../../../../../../assets/fonts/Roboto-Bold.ttf';

Font.register({
	family: 'Roboto',
	fonts: [
		{ src: Roboto },
		{ src: RobotoBold, fontWeight: 'bold' },
	],
});

const styles = StyleSheet.create({
	page: {
		padding: '1cm',
		fontFamily: 'Roboto',
		fontSize: 10,
		color: '#333',
	},
	h1: {
		fontSize: 18,
		fontWeight: 'bold',
		marginBottom: 10,
	},
	tableContainer: {
		marginBottom: 15,
	},
	tableTitle: {
		fontSize: 14,
		fontWeight: 'bold',
		marginBottom: 10,
		fontFamily: 'Roboto',
	},
	tableHeaderCell: {
		padding: 8,
		fontSize: 12,
		fontWeight: 'bold',
		textAlign: 'center',
		fontFamily: 'Roboto',
	},
	tableCell: {
		padding: 8,
		fontSize: 10,
		textAlign: 'center',
	},
	pageNumberContainer: {
		position: 'absolute',
		bottom: 30,
		right: 30,
	},
	pageNumberText: {
		fontSize: 10,
		color: 'grey',
	},
});


interface DrawingSummaryPDFProps {
	drawingFileInfo: DrawingFileInfo
	assetTables: AssetTableData[]
}

export interface AssetTableData {
	headers: { id: number; name: string }[];
	rows: { [key: number]: string }[];
	materialName: string;
}

export const AssetPlanSummaryPDF: React.FC<DrawingSummaryPDFProps> = ({
																		  drawingFileInfo,
																		  assetTables
																	  }) => {
	const imagePadding = 10;
	const pageWidth = drawingFileInfo.width + imagePadding + imagePadding
	const pageHeight = drawingFileInfo.height + imagePadding // + 90

	return (
		<Document>
			<Page size={[pageWidth, pageHeight]} style={styles.page}>
				<Image
					style={{
						height: drawingFileInfo.height,
						paddingTop: imagePadding,
						paddingLeft: imagePadding,
						paddingRight: imagePadding
					}}
					src={drawingFileInfo.url}
				/>
			</Page>
			<Page size={[pageWidth, pageHeight]} break={false} style={styles.page}>
				{assetTables.map((tableData, index) => {
					if (!tableData.headers.length) return null;
					return (
						<View key={index} style={styles.tableContainer}>
							<Text style={styles.tableTitle}>{tableData.materialName}</Text>
							<Table data={tableData.rows} >
								<TableHeader oddRowColor={'#BBBBBB'}>
									{tableData.headers.map(header => (
										<TableCell key={header.id} style={styles.tableHeaderCell}>
											{header.name}
										</TableCell>
									))}
								</TableHeader>
								<TableBody>
									{tableData.headers.map(header => (
										<DataTableCell
											key={header.id}
											style={styles.tableCell}
											getContent={row => row[header.id] || ''}
										/>
									))}
								</TableBody>
							</Table>
						</View>
					);
				})}

				<View style={styles.pageNumberContainer} fixed>
					<Text
						style={styles.pageNumberText}
						render={({ pageNumber, totalPages }) => `${pageNumber} / ${totalPages}`}
					/>
				</View>
			</Page>
		</Document>
	);
};